

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";

/**
 * Converts a dataURL to a Blob object.
 * @param {string} dataURL - The base64 image data (dataURL).
 * @returns {Blob}
 */
function dataURLToBlob(dataURL) {
  if (typeof dataURL !== 'string' || !dataURL.startsWith('data:')) {
    throw new Error('Invalid dataURL provided.');
  }
  const arr = dataURL.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) {
    throw new Error('Invalid dataURL format: MIME type not found.');
  }
  const mime = mimeMatch[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}


/**
 * Uploads a visitor's captured image to Firebase Storage under visitorimg/ folder.
 * @param {string} dataURL - The base64 image data (dataURL).
 * @param {string} visitorId - Unique visitor ID or identifier.
 * @returns {Promise<string>} - The download URL of the uploaded image.
 */
export const uploadVisitorImageToStorage = async (dataURL, visitorId) => {
  if (typeof dataURL !== 'string' || !dataURL.startsWith('data:')) {
    throw new Error('Invalid dataURL provided to uploadVisitorImageToStorage.');
  }
  if (!visitorId || typeof visitorId !== 'string') {
    throw new Error('Invalid visitorId provided to uploadVisitorImageToStorage.');
  }
  try {
    const blob = dataURLToBlob(dataURL);
    const timestamp = Date.now();
    const filePath = `visitorimg/${visitorId}/photo_${timestamp}.jpg`;
    const fileRef = ref(storage, filePath);
    await uploadBytes(fileRef, blob);
    return await getDownloadURL(fileRef);
  } catch (error) {
    console.error(`Error uploading visitor image to storage for visitorId ${visitorId}:`, error);
    throw new Error('Failed to upload visitor image. Please try again.');
  }
};
